const buildQueryBooster = (props, data) => {
  const { recencyBoostProperty } = props;

  if (!recencyBoostProperty || !recencyBoostProperty.length) return data;
  const { rawQueryStringified = '' } = data;

  const parsedRawQuery = JSON.parse(rawQueryStringified);
  const { function_score: { query, functions = [] } = {} } = parsedRawQuery;

  const boostedPropsFunctios = recencyBoostProperty.map(propToBoost => ({
    exp: {
      [propToBoost]: {
        scale: '14d',
        decay: 0.99, // high value slow decay
        offset: '7d'
      }
    }
  }));

  const updatedData = {
    function_score: {
      query: functions.length ? query : parsedRawQuery,
      functions: [
        ...functions,
        ...boostedPropsFunctios,
        {
          weight: 0.01 // minimum score to avoid zeroing out
        }
      ],
      score_mode: 'sum',
      boost_mode: 'multiply'
    }
  };

  return {
    ...data,
    rawQueryStringified: JSON.stringify(updatedData)
  };
};

export default buildQueryBooster;
